<template>
<div>
    <Breadcrumbs main="Admin"  title="Review-Group" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">

                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Group</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">

                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>

                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="items" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>



                                    <template #cell(title)="row">
                                       <div v-if="row.item.title">
                                            <p>{{ row.item.title }}</p>
                                       </div>
                                    </template>
                                   
                                   

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">

                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteinfo(data.item.id)" title="Delete"></feather>
                                            </div>

                                            <div @click="editinfo(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Infography Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Group" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">

     
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Name</label>
                        <input class="form-control" type="text" placeholder="Enter info title" v-model="info.name">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Description</label>
                        <input class="form-control" type="text" placeholder="Enter info title" v-model="info.description">
                    </div>
                </div>
            </div>
           

        </form>
    </b-modal>

    <!-- Infography Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Group" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
      <form ref="form" @submit.stop.prevent="handleEditSubmit()">


        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <label>Name</label>
              <input class="form-control" type="text" placeholder="Enter info title" v-model="edit_info.name">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <label>Description</label>
              <input class="form-control" type="text" placeholder="Enter info title" v-model="edit_info.description">
            </div>
          </div>
        </div>


      </form>
    </b-modal>
    <!-- Gallery Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this Group?</div>
    </b-modal>
</div>
</template>

<script>
  import Datepicker from 'vuejs-datepicker';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import 'sweetalert2/src/sweetalert2.scss';

  import {
    mapState
  } from 'vuex';

  import loader from '../../pages/article19/loader/loader.vue';
  export default {
    components: {
      Datepicker,
      loader
    },

    data() {
      return {
        tablefields: [{
                        key: 'index',
                        label: '#'
                      },
              
               
           
                      {
                        key: 'name',
                        label: 'Name',
                        sortable: true
                      },
                
                      {
                        key: 'description',
                        label: 'Description',
                        sortable: true
                      },
                      {
                        key: 'action',
                        label: 'Action',
                        sortable: false
                      }
        ],
           

        info: {
          name:null,
          description:null,

        },

        edit_info: {
          id: '',
          name:null,
          description:null,

        },

        delete_value: null,
        filter: null,
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [5, 10, 15],

        
      };
    },

    computed: {
        ...mapState({
            group: state => state.manage_user.group,
            loading: state => state.manage_user.participantLoading,
            error: state => state.manage_user.participantError,

        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
            });
        },

    },
    watch:{
      group: function(val, oldVal){
        this.items = this.group;
      }
    },

    mounted() {
      this.$store.dispatch('manage_user/fetchGroupList').then(() => {
        console.log(this.group)
        this.items = this.group;
        this.totalRows = this.items.length;
      });

    },

    methods: {
      uploadFile1(e) {
        const image = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = e => {
          this.show_image1 = e.target.result;
          this.info.first_image = e.target.result;

        };
      },
      uploadFile2(e) {
        const image = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = e => {
          this.show_image2 = e.target.result;
          this.info.sec_image = e.target.result;

        };
      },

      EdituploadFile1(e) {
        const image = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = e => {
          this.show_image1 = e.target.result;
          this.edit_info.first_image = e.target.result;
        };
      },
      EdituploadFile2(e) {
        const image = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = e => {
          this.show_image2 = e.target.result;
          this.edit_info.sec_image = e.target.result;
        };
      },



        
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },

      resetModal() {
        this.info.name = null;
        this.info.description = null;
        
      },

      handleOk(bvModalEvent) {
        bvModalEvent.preventDefault();
        this.handleSubmit();

      },

      handleSubmit() {

        this.$store.dispatch('manage_user/addGroup', this.info).then(response => {

          if (response.code == 201) {
            Swal.fire({
              title: 'Success!',
              text: response.response,
              icon: 'success'
            });

            this.info.name = null;
            this.info.description = null;


          } else {
            Swal.fire({
              title: 'Error!',
              text: response.response,
              icon: 'error'
            });
          }
        });

        this.$nextTick(() => {
          this.$bvModal.hide('modal-prevent-closing');
        });
      },

      editinfo(detail) {
        this.edit_info.id = detail.id ? detail.id : null;
        this.edit_info.name = detail.name ? detail.name : null;
        this.edit_info.description = detail.description ? detail.description : null;


      },
      resetEditModal() {
        this.edit_info.title = null;
        this.edit_info.first_image = null;
        this.edit_info.sec_image = null;
        this.show_image1 = null;
        this.show_image2 = null;

      },

      handleEditOk(bvModalEvent) {
        bvModalEvent.preventDefault();
        this.handleEditSubmit();
      },

      handleEditSubmit() {

        this.$store.dispatch('manage_user/updateGroup', {
          id: this.edit_info.id,
          payload: this.edit_info,

        }).then(response => {

          if (response.code == 200) {
            Swal.fire({
              title: 'Success!',
              text: response.response,
              icon: 'success'
            });

            this.edit_info.title = null;
            this.edit_info.first_image = null;
            this.edit_info.sec_image = null;
            this.show_image1 = null;
            this.show_image2 = null;
                

          } else {
            Swal.fire({
              title: 'Error!',
              text: response.response,
              icon: 'error'
            });
          }
        });

        this.$nextTick(() => {
          this.$bvModal.hide('modal-prevent-closing-edit');
        });
      },
      deleteinfo(id) {
        this.delete_value = id;
      },
      handleDeleteOk() {
        this.$store.dispatch('manage_user/deleteGroup', {
          delete: this.delete_value
        }).then(response => {
          if (response.code == 200) {
            Swal.fire({
              title: 'Success!',
              text: response.response,
              icon: 'success'
            });

            this.delete_value = null;

          } else {
            Swal.fire({
              title: 'Error!',
              text: response.response,
              icon: 'error'
            });
          }
        });
      }
    }
  };
</script>
